import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Config } from 'src/infrastructure/config';
import { AvailableFilters } from 'src/models/DTO/filters/availableFilters';

@Injectable({
  providedIn: 'root'
})
export class FiltersService {

  private availableFiltersURL : string = Config.api + 'product/available_filters?filter[categories]=';
  private availableFiltersForChildCategoryURL : string = Config.api + 'product/available_filters?filter[childCategory]=';


  constructor(private http: HttpClient) { }

  getAvailableFilters(categoryUUID: string) {
    return this.http.get<AvailableFilters>(this.availableFiltersURL + categoryUUID);
  }

  getAvailableFiltersForChildCategory(childCategoryUUID: string) {
    return this.http.get<AvailableFilters>(this.availableFiltersForChildCategoryURL + childCategoryUUID);
  }
}
